import type { ReactElement, ReactNode } from 'react';

export function Card({
  children,
  flat = false,
}: {
  children: ReactNode;
  flat?: boolean;
}): ReactElement {
  return <section className={`card${flat ? ' card--flat' : ''}`}>{children}</section>;
}

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}): ReactElement {
  return (
    <div className="empty-state">
      <h3>{title}</h3>
      {description !== undefined ? <p>{description}</p> : null}
      {action}
    </div>
  );
}

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}): ReactElement {
  // A plain div, not a <header>: the site header is already the page's banner
  // landmark, and a second one makes the landmarks useless to navigate by.
  return (
    <div className="page-header">
      <div className="page-header__text">
        <h1>{title}</h1>
        {subtitle !== undefined ? <div className="page-header__subtitle">{subtitle}</div> : null}
      </div>
      {actions !== undefined ? <div className="row">{actions}</div> : null}
    </div>
  );
}
